import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b415ec50")

_pushScopeId("data-v-b415ec50")
const _hoisted_1 = { class: "text-10px label-accordion font-light" }
const _hoisted_2 = {
  key: 0,
  class: "w-full px-6 py-4 border-r border-l border-b rounded-b-md border-gray-lp-400 text-gray-lp-300"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAccordion && _ctx.toggleAccordion(...args))),
      class: ["border-gray-lp-400 leading-tight font-normal", 
        `
        ${
          _ctx.disabled
            ? 'cursor-not-allowed text-gray-lp-600'
            : 'cursor-pointer text-black-lp-300'
        } ${_ctx.bgColor} flex flex-wrap flex-row items-center justify-between ${
          _ctx.modelAccordion
            ? `${_ctx.borderHeader} ${_ctx.roundedHeader} py-2`
            : _ctx.footer
            ? 'rounded-t-md border-l border-t border-r pb-0 pt-4'
            : `rounded-md ${_ctx.borderHeader} py-2 `
        }
        ${_ctx.customClass}`
      ]
    }, [
      _createVNode("div", { class: _ctx.customWidthHeader }, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createVNode("div", {
            class: `${_ctx.titleFontWeight} label-accordion`
          }, [
            (_ctx.customLabel)
              ? _renderSlot(_ctx.$slots, "custom-label", { key: 0 }, undefined, true)
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.label), 1)
                ], 64)),
            _createVNode("div", _hoisted_1, _toDisplayString(_ctx.caption), 1)
          ], 2)
        ], {}, true)
      ], 2),
      _createVNode("img", {
        src: require(`@/app/ui/assets/svg/${_ctx.expandIcon}.svg`),
        class: "w-6 justify-self-end",
        alt: "expand"
      }, null, 8, ["src"])
    ], 2),
    _withDirectives(_createVNode("div", {
      class: 
        `w-full ${_ctx.mainBorderEdge} ${
          _ctx.footer ? '' : 'rounded-b-md'
        }  ${_ctx.borderBody}text-gray-lp-300`
      
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2), [
      [_vShow, _ctx.modelAccordion]
    ]),
    (_ctx.footer)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
})